import axios from "axios";

console.log('process.env.REACT_APP_ENV: ', process.env.REACT_APP_ENV);

const DJANGO_BASE_URL = (
    (process.env.REACT_APP_ENV === "development") ? "https://staging.gu-plat.com/api" :
    (process.env.REACT_APP_ENV === "qa") ? "https://staging.gu-plat.com/api" :
    (process.env.REACT_APP_ENV === "production") ? "https://partner.giddyup.io/api" : ''
);

const DJANGO_TOKEN = (
    (process.env.REACT_APP_ENV === "development") ? "5c37a7521781b206b634108987d418251cdace1f" :
    (process.env.REACT_APP_ENV === "qa") ? "5c37a7521781b206b634108987d418251cdace1f" :
    (process.env.REACT_APP_ENV === "production") ? "b66ca433e73fa92c568ae8e4e0a27db4d616dd9f" : ''
);

const v3Client = axios.create({
    baseURL: DJANGO_BASE_URL,
});

// Add an interceptor to include the Authorization header in all requests
v3Client.interceptors.request.use(
    (config) => {
        if (DJANGO_TOKEN) {
            config.headers.Authorization = `Token ${DJANGO_TOKEN}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default v3Client;